var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "90px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "姓名/手机号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.keyword,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "keyword", $$v)
                                },
                                expression: "listPram.keyword",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.storeType
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "归属商家" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth ",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.handleSelectedList },
                                  model: {
                                    value: _vm.listPram.offlineSupplierId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.listPram,
                                        "offlineSupplierId",
                                        $$v
                                      )
                                    },
                                    expression: "listPram.offlineSupplierId",
                                  },
                                },
                                _vm._l(_vm.formStoreSelect, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.supplierName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "归属门店" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.offlineStoreId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "offlineStoreId", $$v)
                                },
                                expression: "listPram.offlineStoreId",
                              },
                            },
                            _vm._l(_vm.formStoreSelected, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "mr20",
                          attrs: { type: "primary" },
                          on: { click: _vm.handerSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "mr20",
                          attrs: { type: "primary" },
                          on: { click: _vm.handleAddUser },
                        },
                        [_vm._v("添加员工")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "mr20",
                          attrs: { type: "primary" },
                          on: { click: _vm.handleOpenDolaPopup },
                        },
                        [_vm._v("导入员工")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "adminName", label: "姓名", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: "登录手机号",
                  "min-width": "50",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "员工状态", "min-width": "50" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                            "inactive-text": "停用",
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "启用",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.chanageCpStatus(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "offlineStoreName",
                  label: "归属门店",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "roleName", label: "权限", "min-width": "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "refundAuth",
                  label: "退款权限",
                  "min-width": "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(scope.row.refundAuth === 1 ? "是" : "否") +
                            "\n\t\t\t\t"
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "80",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditListEnd(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleNewEditPasswrod(scope.row)
                              },
                            },
                          },
                          [_vm._v("重置密码")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDedelete(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.titleType ? "添加员工" : "编辑信息",
                visible: _vm.dialogVisible,
                width: "35%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
                close: _vm.closedialog,
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.form,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "员工姓名", prop: "adminName" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.adminName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "adminName", $$v)
                          },
                          expression: "form.adminName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "登录手机号", prop: "phone" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.storeType
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "所属商家" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择商家",
                              },
                              on: { change: _vm.handleDoladinSelecte },
                              model: {
                                value: _vm.form.offlineSupplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "offlineSupplierId", $$v)
                                },
                                expression: "form.offlineSupplierId",
                              },
                            },
                            _vm._l(_vm.formStoreSelect, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.supplierName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属门店" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择门店",
                          },
                          model: {
                            value: _vm.form.offlineStoreIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "offlineStoreIds", $$v)
                            },
                            expression: "form.offlineStoreIds",
                          },
                        },
                        _vm._l(
                          _vm.formStoreSelectedDoadin,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.value, value: item.key },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "角色", prop: "roleList" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { multiple: "", placeholder: "请选择角色" },
                          model: {
                            value: _vm.form.roleList,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "roleList", $$v)
                            },
                            expression: "form.roleList",
                          },
                        },
                        _vm._l(
                          _vm.offsetStateOptionRoles,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.value, value: item.key },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status",
                          },
                        },
                        [
                          _c("el-radio", { key: 1, attrs: { label: 1 } }, [
                            _vm._v("开启"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { key: 0, attrs: { label: 0 } }, [
                            _vm._v("停用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "退款权限", prop: "refundAuth" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.refundAuth,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "refundAuth", $$v)
                            },
                            expression: "form.refundAuth",
                          },
                        },
                        [
                          _c("el-radio", { key: 1, attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { key: 0, attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleAddUserSubmit },
                        },
                        [_vm._v("确定")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.closedialog } }, [
                        _vm._v("取消"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "导入添加员工",
                visible: _vm.dialogAddVisible,
                width: "35%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogAddVisible = $event
                },
                close: _vm.closedialog,
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "80px" },
                },
                [
                  _c("el-form-item", { attrs: { label: "上传文件" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "ButtonUploadExcel",
                          {
                            attrs: {
                              beforeUpload: function (file) {
                                return _vm.beforeUpload(file)
                              },
                            },
                          },
                          [_vm._v("上传文件")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "20px" },
                            attrs: { type: "success" },
                            on: { click: _vm.addDowExcel },
                          },
                          [_vm._v("下载模板")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "上传文件" } }, [
                    _c("div", [_vm._v("支持文件：.xlsx .xls .csv")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "导入的文件需包含字段：员工姓名,登录手机号,供应商ID（商户账号不传）,归属门店ID,员工状态,角色ID"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "导入信息" } }, [
                    _c("div", {
                      staticStyle: { color: "red" },
                      domProps: { innerHTML: _vm._s(_vm.dowCoExcleText) },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialogAddVisible = _vm.fasle
                            },
                          },
                        },
                        [_vm._v("关闭")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }